/** 지도·결함 리스트 공통 — 결함 유형 아이콘·표시명 */

export const DEFECT_TYPE_ICONS_URI = '/img/icons/defect/';

export function normalizeDefectTypeCode(value) {
  return String(value ?? '')
    .trim()
    .toLowerCase()
    .replace(/_/g, '-');
}

/**
 * @param {{ defectType?: string, defectCode?: { code?: string }|string, defect_code?: string }} item
 */
export function resolveDefectTypeIconKey(item) {
  const fromCode =
    item?.defectCode != null && typeof item.defectCode === 'object'
      ? item.defectCode.code
      : item?.defectCode ?? item?.defect_code;
  const raw = item?.defectType ?? fromCode;
  if (raw == null || raw === '') {
    return 'cell';
  }
  if (typeof raw === 'object' && raw.code) {
    return normalizeDefectTypeCode(raw.code) || 'cell';
  }
  return normalizeDefectTypeCode(raw) || 'cell';
}

export function getDefectTypeIconUrl(item) {
  return `${DEFECT_TYPE_ICONS_URI}${resolveDefectTypeIconKey(item)}.png`;
}

/**
 * @param {string} code
 * @param {Array<{ code?: string, name?: string, children?: Array }>} parentTypes
 */
export function findDefectTypeRecordByCode(code, parentTypes = []) {
  const target = normalizeDefectTypeCode(code);
  if (!target) {
    return null;
  }
  for (const parent of parentTypes) {
    if (normalizeDefectTypeCode(parent?.code) === target) {
      return parent;
    }
    for (const child of parent?.children || []) {
      if (normalizeDefectTypeCode(child?.code) === target) {
        return child;
      }
    }
  }
  return null;
}

/**
 * @param {object} item
 * @param {Array} parentTypes
 */
export function resolveDefectTypeDisplayName(item, parentTypes = []) {
  const key = resolveDefectTypeIconKey(item);
  const record = findDefectTypeRecordByCode(key, parentTypes);
  if (record?.name) {
    return record.name;
  }
  if (item?.defectDesc) {
    return item.defectDesc;
  }
  if (item?.defectType && typeof item.defectType === 'string') {
    return item.defectType;
  }
  return '';
}
